import { defaultAstarEvmProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/astar-evm/default-constants';

export const ARTH_SWAP_CONTRACT_ADDRESS = '0xE915D2393a08a00c5A463053edD31bAe2199b9e7';

export const ARTH_SWAP_PROVIDER_CONFIGURATION = defaultAstarEvmProviderConfiguration;
